import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { JobType } from './job-type.interface';

export class JobTypeService {
   async getJobTypes(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<JobType>>>(`/nxt-job-types`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
